module.exports = __webpack_public_path__ + "static/sec9-shoe-water2-912d5a8b7539ac2cbab67e6c91cefde2.png";